import { Fragment } from "react";


const currencyReplacer = (text: string, title: string, symbol: string) => <>
  {
    text?.split(symbol).map((part, index, array) => (
      index < array.length - 1 ?
        <Fragment key={`symbol-string-part-${index}`}>
          {part}
          <span data-currency-symbol translate="no" className="notranslate" title={title}>{symbol}</span>
        </Fragment>
        :
        part
    ))
  }
</>;


export const FormatCurrencyForDisplay = (originalCurrency: string, asString?: boolean) => {
  if (originalCurrency === undefined) return undefined;

  const currencies = {
    SAR: {
      replacebles: ['SAR', 'ريال سعودي'],
      symbol: '\uFAA5',
      title: 'SAR - ريال سعودي',
    },
    AED: {
      replacebles: ['AED', 'درهم إماراتي', 'درهم اماراتي'],
      symbol: '\uFAA4',
      title: 'AED - درهم إماراتي',
    },
    OMR:{
      replacebles: ['OMR', 'ريال عماني'],
      symbol: '\uFAA6',
      title: 'OMR - ريال عماني',
    }
  };

  let replacedSymbolString = originalCurrency.toString();
  let displayCurrency: string | JSX.Element = originalCurrency;


  for (const keysOfCurrencies of Object.keys(currencies) as Array<keyof typeof currencies>) {
    const { replacebles, symbol, title } = currencies[keysOfCurrencies];

    for (const replacebleValue of replacebles) {
      replacedSymbolString = replacedSymbolString.split(replacebleValue).join(symbol);

      if (replacebles.includes(originalCurrency)) {
        displayCurrency = <span data-currency-symbol translate="no" className="notranslate" title={title}>{symbol}</span>;
      } else if (replacedSymbolString.includes(symbol)) {
        displayCurrency = currencyReplacer(replacedSymbolString, title, symbol);
      }
    };
  };

  return asString ? replacedSymbolString : displayCurrency;
};